<template>
  <div>
    <div class="col-lg-9 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn padbtn">
          <button class="btn btn-secondary" @click="$router.go(-1);">
            <i class="fa fa-chevron-left"></i>
            Regresar
          </button>
        </div>
        <hr />
        <form v-if="canCreate() || canUpdate()" @submit.prevent="validateForm('plannings_documents', '/planningdocuments', 'planningEdit')">
          <div class="row">
            <div class="col-md-6">
              <label>Proyecto</label>
              <el-select class="select-primary select_modules"
              v-model="model.demand_id"
              filterable placeholder="Seleccione un proyecto">
                <el-option v-for="option in $store.state.auth.user.demands"
                            class="select-primary"
                            :value="option.id"
                            :label="option.code+' - '+option.name"
                            :key="option.name">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <fg-input
                type="text"
                label="Nombre *"
                v-model="model.name"
                v-validate="modelValidations.name"
                name="nombre del documento de planeación"
                :error="getError('nombre del documento de planeación')"
                :disabled="disabledField"
              ></fg-input>
            </div>
            <div class="col-md-6">
              <label>Fecha *</label>
              <el-date-picker
                v-model="model.date"
                type="date"
                placeholder="Seleccione una fecha"
              ></el-date-picker>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <fg-input label="Descripción">
                <textarea v-model="model.description" class="form-control" rows="3"></textarea>
              </fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label>Anexos *</label>
              <el-upload
                drag
                multiple
                ref="upload"
                action="https://dialnet.aplicacionescorporativas.com/dialnet-backend/api/auth/plannings_documents"
                @on-change="handleSuccess('planningEdit')"
                :data="model"
                :on-preview="handlePreview"
                :on-change="handleSuccess"
                :file-list="annexes"
                :auto-upload="false">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  Suelta tus documentos aquí o <em>haz clic para cargar</em>
                </div>
                <div slot="tip" class="el-upload__tip">Solo archivos <span style="color: #409eff;">.pdf / .excel / .word / .jpg / .png / .zip / .rar</span></div>
              </el-upload>
            </div>
          </div>
          <div class="row" v-if="errorAlert ">
            <div class="col-lg-12">
              <el-alert :title="errorAlert" type="error"></el-alert>
            </div>
          </div>
          <br />
          <hr />
          <br />
          <div class="text-center">
            <button type="submit" class="btn btn-fill btn-warning btn-wd">Guardar</button>
          </div>
        </form>
        <div v-else>
          <div class="text-center">
            <h4>
              <strong>No tienes permiso para crear o editar</strong>
            </h4>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import mixinMasters from "src/util/mixinMasters";
import mixinPermissions from "src/util/mixinPermissions";
import mixinUpload from 'src/util/mixinUpload'

export default {
  mixins: [mixinMasters, mixinPermissions, mixinUpload],
  created() {
    if (this.canCreate() || this.canUpdate()) {
      if (localStorage.getItem("planningEdit")) {
        this.$emit('cotentLoading', true)
        setTimeout(() => {
          this.model = JSON.parse(localStorage.getItem("planningEdit"));
          this.annexes = JSON.parse(this.model.files_list);
          this.$emit('cotentLoading')
        }, 1000);
      }
    }
  },
  beforeDestroy() {
    localStorage.removeItem("planningEdit");
  },
};
</script>
